export const SET_SCREEN: string = 'SET_SCREEN';
export const SET_MODAL: string = 'SET_MODAL';
export const SET_POPUP: string = 'SET_POPUP';
export const HIDE_POPUP: string = 'HIDE_POPUP';
export const SET_TOOLTIP: string = 'SET_TOOLTIP';

export const SHOW_GAME_INTRO: string = 'SHOW_GAME_INTRO';
export const START_GAME: string = 'START_GAME';
export const RESUME_GAME: string = 'RESUME_GAME';


export const SET_SELECTED_LOCATION: string = 'SET_SELECTED_LOCATION';
export const SET_HIGHLIGHT_LOCATION: string = 'SET_HIGHLIGHT_LOCATION';
export const CLEAR_SELECTED_LOCATION: string = 'CLEAR_SELECTED_LOCATION';
export const SET_MAP_OFFSET: string = 'SET_MAP_OFFSET';
export const SET_MAP_BOUNDS: string = 'SET_MAP_BOUNDS';


export const SET_SELECTED_POWER_SOURCE: string = 'SET_SELECTED_POWER_SOURCE';
export const ADD_POWER_SOURCE_AT_LOCATION: string = 'ADD_POWER_SOURCE_AT_LOCATION';
export const SET_DRAGGING_POWER_SOURCE: string = 'SET_DRAGGING_POWER_SOURCE';
export const PLACE_POWER_SOURCE: string = 'PLACE_POWER_SOURCE';
export const REMOVE_POWER_SOURCE: string = 'REMOVE_POWER_SOURCE';
export const REMOVE_ALL_POWER_SOURCES: string = 'REMOVE_ALL_POWER_SOURCES';
export const RESET_ALL_POWER_SOURCES: string = 'RESET_ALL_POWER_SOURCES';
export const BREAK_POWER_SOURCE_TYPE: string = 'BREAK_POWER_SOURCE_TYPE';
export const REMOVE_ALL_POWER_SOURCE_TYPE: string = 'REMOVE_ALL_POWER_SOURCE_TYPE';
export const SAVE_POWER_SOURCE_COUNTS: string = 'SAVE_POWER_SOURCE_COUNTS_BY_TYPE';


export const DAMAGE_SOURCE_TYPE: string = 'DAMAGE_SOURCE_TYPE';
export const CLEAR_ALL_DAMAGE: string = 'CLEAR_ALL_DAMAGE';
export const SET_INITIAL_DAMAGE: string = 'SET_INITIAL_DAMAGE';
export const REPAIR_STATION_AT_LOCATION: string = 'REPAIR_STATION_AT_LOCATION';

export const DEPRECATE_SOURCE_TYPE: string = 'DEPRECATE_SOURCE_TYPE';
export const CLEAR_ALL_DEPRECATIONS: string = 'CLEAR_ALL_DEPRECATIONS';
export const REMOVE_ALL_DEPRECATED_STATIONS: string = 'REMOVE_ALL_DEPRECATED_STATIONS';
export const REMOVE_STATIONS: string = 'REMOVE_STATIONS';
export const SET_INITIAL_DEPRECATIONS: string = 'SET_INITIAL_DEPRECATIONS';



export const START_TIMER: string = 'START_TIMER';
export const TICK_TIMER: string = 'TICK_TIMER';
export const STOP_TIMER: string = 'STOP_TIMER';
export const PAUSE_TIMER: string = 'PAUSE_TIMER';
export const RESUME_TIMER: string = 'RESUME_TIMER';
export const RESET_TIMER: string = 'RESET_TIMER';
export const TIMER_HAS_EXPIRED: string = 'TIMER_HAS_EXPIRED';
export const SKIP_TIMER: string = 'SKIP_TIMER';

export const CHOOSE_GENERAL_HINT: string = 'CHOOSE_SUITABLE_HINT';
export const CHOOSE_INCREASE_POWER_SOURCE_HINT: string = 'CHOOSE_INCREASE_POWER_SOURCE_HINT';
export const CHOOSE_DECREASE_POWER_SOURCE_HINT: string = 'CHOOSE_DECREASE_POWER_SOURCE_HINT';
export const CHOOSE_SUITABLE_OUTAGE: string = 'CHOOSE_SUITABLE_OUTAGE';
export const CHOOSE_SUITABLE_EVENT: string = 'CHOOSE_SUITABLE_EVENT';


export const SET_ENERGY_DEMAND: string = 'SET_ENERGY_DEMAND';
export const SET_CARBON_TARGET: string = 'SET_CARBON_TARGET';
export const SET_CARBON_OUTPUT: string = 'SET_CARBON_OUTPUT';


export const SHOW_HINT: string = 'SHOW_HINT';
export const SET_OUTAGE_ID: string = 'SET_OUTAGE_ID';
export const SET_DEPRECATE_TYPE: string = 'SET_DEPRECATE_TYPE';
export const SHOW_QUESTION: string = 'SHOW_QUESTION';
export const SHOW_NEXT_OUTAGE_QUESTION: string = 'SHOW_NEXT_OUTAGE_QUESTION';
export const SHOW_NEXT_YEAR_END_QUESTION: string = 'SHOW_NEXT_YEAR_END_QUESTION';
export const CHOOSE_ANSWER: string = 'CHOOSE_ANSWER';
export const SET_EVENT_ID: string = 'SET_EVENT_ID';
export const SHOW_POWER_SOURCE_DETAILS: string = 'SHOW_POWER_SOURCE_DETAILS';

export const SET_MINI_GAME_ID: string = 'SET_MINI_GAME_ID';
export const CLEAR_MINI_GAME_ID: string = 'CLEAR_MINI_GAME_ID';
export const ACTIVATE_MINI_GAME: string = 'ACTIVATE_MINI_GAME';



export const START_DRAGGING: string = 'START_DRAGGING';
export const STOP_DRAGGING: string = 'STOP_DRAGGING';


export const TOGGLE_DEBUG_CONSOLE: string = 'TOGGLE_DEBUG_CONSOLE';

export const SET_SCORE: string = 'SET_SCORE';
export const UPDATE_SCORE: string = 'UPDATE_SCORE';
export const ADD_SCORE: string = 'ADD_SCORE';
export const RECORD_CORRECT_ANSWER: string = 'RECORD_CORRECT_ANSWER';
export const RESET_CORRECT_ANSWERS_COUNT: string = 'RESET_CORRECT_ANSWERS_COUNT';
export const RECORD_ENERGY_GENERATED: string = 'RECORD_ENERGY_GENERATED';
export const RESET_ENERGY_GENERATED: string = 'RESET_ENERGY_GENERATED';


export const SET_SEASON: string = 'SET_SEASON';
export const RESET_SEASON: string = 'RESET_SEASON';
export const NEXT_SEASON: string = 'NEXT_SEASON';
export const TRIGGER_SEASONAL_CONTENT: string = 'TRIGGER_SEASONAL_CONTENT';
export const TEST_ANNUAL_TARGETS: string = 'TEST_ANNUAL_TARGETS';

export const SET_YEAR: string = 'SET_YEAR';
export const INCREMENT_YEAR: string = 'INCREMENT_YEAR';
export const START_YEAR: string = 'START_YEAR';
export const END_YEAR: string = 'END_YEAR';

export const OPEN_RESULTS_PANEL: string = 'OPEN_RESULTS_PANEL';
export const CLOSE_RESULTS_PANEL: string = 'CLOSE_RESULTS_PANEL';
export const RESET_RESULTS_PANEL: string = 'RESET_RESULTS_PANEL';



// WEBPACK FOOTER //
// ./src/ts/store/actions/action.ts